import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

/**
 * Lets embedded Manage Network notify Account Admin after the first kiln is added
 * (quick-setup walkthrough flow).
 */
@Injectable()
export class AccountAdminKilnFlowService {
  private readonly kilnAdded$ = new Subject<void>();

  readonly onKilnAddedInSetup$ = this.kilnAdded$.asObservable();

  notifyKilnAddedFromWalkthroughSetup(): void {
    this.kilnAdded$.next();
  }
}
